<sc-flex vertical fitHeight stretchContent class="no-field-space">
  <sc-dialog-title>
    <sc-dictionary-label
    dictionaryKey="tmc-yard.ui.admin.filter-administration.filter-mail-schedule.title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-flex-fitting-content vertical class="no-field-space">
    <sc-master-detail [data]="visiblefilterMailSchedules" [readOnly]="false" [selection]="[selectedEntry]"
      (selectionChanged)="handleSelectionChange($event)" (addEntry)="onAddEntry($event);"
      (deleteEntry)="onDeleteEntry($event);">

      @if (selectedEntry) {
        <app-filter-mail-schedule-editor [filterMailSchedule]="selectedEntry"
        (entryChanged)="onEntryChanged()"></app-filter-mail-schedule-editor>
      }

    </sc-master-detail>
  </sc-flex-fitting-content>


  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="onCancel()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-save-button primary (click)="onSave()" [disabled]="!saveEnabled"></sc-save-button>
  </sc-actionbar>

</sc-flex>
